import type { JSX } from 'react';
import { DownloadOutlined, FileImageOutlined, FileOutlined, FilePdfOutlined, PaperClipOutlined } from '@ant-design/icons';

import type { NewsAttachmentDto } from '../../lib/wikiApi';

// ─── Вложения новости: чипы со скачиванием (cookie-auth прямой ссылкой) ─
export function fmtSize(bytes: number): string {
  if (bytes < 1024) return `${bytes} Б`;
  if (bytes < 1024 * 1024) return `${Math.round(bytes / 1024)} КБ`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} МБ`;
}
function attIcon(type: string, mime: string): JSX.Element {
  if (type === 'PDF' || mime === 'application/pdf') return <FilePdfOutlined style={{ color: 'var(--fk-error)' }} />;
  if (type === 'IMAGE' || mime.startsWith('image/')) return <FileImageOutlined style={{ color: 'var(--fk-info)' }} />;
  return <FileOutlined style={{ color: 'var(--fk-text-2)' }} />;
}
export function NewsAttachments({ newsId, attachments }: { newsId: string; attachments: NewsAttachmentDto[] }): JSX.Element | null {
  if (!attachments.length) return null;
  return (
    <div style={{ marginTop: 18 }}>
      <div style={{ fontSize: 12, fontWeight: 700, color: 'var(--fk-text-2)', marginBottom: 8, display: 'flex', alignItems: 'center', gap: 6 }}>
        <PaperClipOutlined /> Вложения ({attachments.length})
      </div>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
        {attachments.map((a) => (
          <a
            key={a.id}
            href={`/api/news/${encodeURIComponent(newsId)}/attachments/${encodeURIComponent(a.id)}/file`}
            target="_blank"
            rel="noopener noreferrer"
            style={{
              display: 'flex', alignItems: 'center', gap: 10, padding: '9px 12px',
              border: '1px solid var(--fk-border)', borderRadius: 'var(--fk-radius-md)',
              background: 'var(--fk-bg-subtle)', textDecoration: 'none', color: 'inherit',
            }}
          >
            <span style={{ fontSize: 18, display: 'flex' }}>{attIcon(a.type, a.mimeType)}</span>
            <span style={{ flex: 1, minWidth: 0 }}>
              <span style={{ display: 'block', fontSize: 13.5, fontWeight: 600, color: 'var(--fk-indigo)', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{a.fileName}</span>
              <span style={{ fontSize: 11, color: 'var(--fk-text-muted)' }}>{fmtSize(a.fileSize)}</span>
            </span>
            <DownloadOutlined style={{ color: 'var(--fk-orange)' }} />
          </a>
        ))}
      </div>
    </div>
  );
}
